/* ═══════════════════════════════════════════════════════════
   ACCESORIOS CUSTOM JS — site-wide custom behaviours
   Loaded once via layout/theme.liquid (defer). To add a new feature:
   append a self-contained IIFE under a section header below.
   ═══════════════════════════════════════════════════════════ */

/* a11y: Shopify's video_tag generates a poster <img> with no alt attribute.
   The poster is decorative (the <video> is the real content), so empty alt is correct. */
(function () {
  function fixVideoPosterAlt() {
    document.querySelectorAll('video img:not([alt])').forEach(function (img) { img.setAttribute('alt', ''); });
  }
  if (document.readyState !== 'loading') fixVideoPosterAlt();
  else document.addEventListener('DOMContentLoaded', fixVideoPosterAlt);
})();


/* ════════════════════════════════════════════════
   1. PRODUCT CARD EXTRAS (acc-pce)
   Reads optional per-template config from #acc-pce-config JSON blob.
   Mounts extras inside every <product-card>, wraps price for centring/alignment,
   splits title at em-dash, prefetches media + cycles images on hover.
   Extracted from inline <script> for PageSpeed (was duplicated per-card).
   ════════════════════════════════════════════════ */

(function(){
  if (window.__accProductCardExtrasInit) return;
  window.__accProductCardExtrasInit = true;

  var CFG = {
    show_compat: true, show_swatches: true, show_features: true, show_discount: true,
    show_hover_cycle: true, max_features: 3,
    discount_bg: '#2C5C4E', discount_text: '#FFFFFF',
    compat_label: 'For:', title_delimiter: ' — ', hover_delay_ms: 700,
    title_meta_size_px: 14, title_meta_color: '#3F3F3D',
    feature_pill_bg: '#FAF5EE', feature_pill_check_bg: '#2C5C4E',
    override_features: true,
    // Locked pills (no rotation) — all flip covers share these brand-promise features.
    // Showing the same 3 on every card communicates brand reliability, not data inconsistency.
    rotate_features: false,
    features_list: [
      'Magnetic Closure', 'Built-in Kickstand', 'Carry Card + Cash'
    ]
  };
  try {
    var cfgEl = document.getElementById('acc-pce-config');
    if (cfgEl && cfgEl.textContent) {
      var parsed = JSON.parse(cfgEl.textContent);
      Object.keys(parsed).forEach(function(k){ if (parsed[k] !== null && parsed[k] !== undefined) CFG[k] = parsed[k]; });
    }
  } catch(e) {}

  function applyCfgVars(root){
    var s = (root || document.documentElement).style;
    s.setProperty('--acc-pce-discount-bg', CFG.discount_bg);
    s.setProperty('--acc-pce-discount-text', CFG.discount_text);
    s.setProperty('--acc-pce-title-meta-size', CFG.title_meta_size_px + 'px');
    s.setProperty('--acc-pce-title-meta-color', CFG.title_meta_color);
    s.setProperty('--acc-pce-pill-bg-start', CFG.feature_pill_bg);
    s.setProperty('--acc-pce-pill-check-bg', CFG.feature_pill_check_bg);
  }
  applyCfgVars(document.documentElement);

  function mountExtras(){
    document.querySelectorAll('[data-acc-product-extras]:not(.acc-pce--mounted)').forEach(function(el){
      var card = el.closest('product-card');
      if (!card) {
        var prev = el.previousElementSibling;
        if (prev && prev.tagName === 'PRODUCT-CARD' && !prev.contains(el)) {
          var target = prev.querySelector('.product-card__info, .product-card__body, .v-stack.gap-2, .product-card > .v-stack')
                    || prev.querySelector('.v-stack')
                    || prev;
          target.appendChild(el);
          card = prev;
        }
      }
      var compat = el.querySelector('.acc-pce__compat');
      if (compat) {
        if (!CFG.show_compat) { compat.style.display = 'none'; }
        else {
          var lbl = compat.querySelector('.acc-pce__compat-label');
          if (lbl && CFG.compat_label) lbl.textContent = CFG.compat_label;
        }
      }
      var swatches = el.querySelector('.acc-pce__swatches');
      if (swatches && !CFG.show_swatches) swatches.style.display = 'none';
      var featuresList = el.querySelector('.acc-pce__features');
      if (featuresList && featuresList.hasAttribute('data-acc-own-features')) {
        // Non-phone-case products (mouse pads) render their own pills — never override with flip-cover features
        if (!CFG.show_features) featuresList.style.display = 'none';
      } else if (featuresList) {
        if (!CFG.show_features) {
          featuresList.style.display = 'none';
        } else {
          var maxF = parseInt(CFG.max_features, 10) || 3;
          if (CFG.override_features && Array.isArray(CFG.features_list)) {
            var pool = CFG.features_list.filter(function(s){ var v = String(s||'').trim(); return v && v.toLowerCase() !== 'none'; });
            var newPills = [];
            if (pool.length > 0) {
              if (CFG.rotate_features) {
                // Per-product hash rotation (only if explicitly enabled)
                var cardForHash = el.closest('product-card');
                var hkey = (cardForHash && (cardForHash.getAttribute('handle') || cardForHash.dataset.productHandle)) || el.getAttribute('data-product-handle') || '';
                var h = 0; for (var hi = 0; hi < hkey.length; hi++) { h = ((h << 5) - h) + hkey.charCodeAt(hi); h |= 0; }
                var offset = Math.abs(h) % pool.length;
                for (var pi = 0; pi < maxF && pi < pool.length; pi++) {
                  newPills.push(pool[(offset + pi) % pool.length]);
                }
              } else {
                // Locked: take first N pills, every card identical (brand-promise mode)
                for (var pj = 0; pj < maxF && pj < pool.length; pj++) {
                  newPills.push(pool[pj]);
                }
              }
            }
            if (newPills.length > 0) {
              featuresList.innerHTML = '';
              newPills.forEach(function(name, i){
                var li = document.createElement('li');
                li.setAttribute('data-acc-feature-idx', i);
                li.textContent = String(name).trim();
                featuresList.appendChild(li);
              });
            } else {
              featuresList.style.display = 'none';
            }
          } else {
            featuresList.querySelectorAll('li').forEach(function(li, i){
              if (i >= maxF) li.style.display = 'none';
            });
            if (featuresList.children.length === 0) featuresList.style.display = 'none';
          }
        }
      } else if (CFG.show_features && CFG.override_features && Array.isArray(CFG.features_list)) {
        var pool2 = CFG.features_list.filter(function(s){ var v = String(s||'').trim(); return v && v.toLowerCase() !== 'none'; });
        var pillsToAdd = [];
        var maxF2 = parseInt(CFG.max_features, 10) || 3;
        if (pool2.length > 0) {
          if (CFG.rotate_features) {
            var cardForHash2 = el.closest('product-card');
            var hkey2 = (cardForHash2 && (cardForHash2.getAttribute('handle') || cardForHash2.dataset.productHandle)) || el.getAttribute('data-product-handle') || '';
            var h2 = 0; for (var hi2 = 0; hi2 < hkey2.length; hi2++) { h2 = ((h2 << 5) - h2) + hkey2.charCodeAt(hi2); h2 |= 0; }
            var offset2 = Math.abs(h2) % pool2.length;
            for (var pi2 = 0; pi2 < maxF2 && pi2 < pool2.length; pi2++) {
              pillsToAdd.push(pool2[(offset2 + pi2) % pool2.length]);
            }
          } else {
            for (var pj2 = 0; pj2 < maxF2 && pj2 < pool2.length; pj2++) {
              pillsToAdd.push(pool2[pj2]);
            }
          }
        }
        if (pillsToAdd.length > 0) {
          var newList = document.createElement('ul');
          newList.className = 'acc-pce__features';
          newList.setAttribute('aria-label', 'Features');
          pillsToAdd.forEach(function(name, i){
            var li = document.createElement('li');
            li.setAttribute('data-acc-feature-idx', i);
            li.textContent = String(name).trim();
            newList.appendChild(li);
          });
          var swEl = el.querySelector('.acc-pce__swatches');
          if (swEl && swEl.nextSibling) swEl.parentNode.insertBefore(newList, swEl.nextSibling);
          else el.appendChild(newList);
        }
      }
      var discountEl = el.querySelector('.acc-pce__discount');
      if (discountEl && !CFG.show_discount) discountEl.style.display = 'none';
      var cardRef = el.closest('product-card');
      var discount = el.querySelector('.acc-pce__discount');
      if (cardRef) {
        var priceTarget = cardRef.querySelector('.price-list, .product-card__price, .price, .price__current, sale-price');
        if (priceTarget && !priceTarget.parentElement.classList.contains('acc-pce-price-wrap')) {
          var wrap = document.createElement('div');
          wrap.className = 'acc-pce-price-wrap';
          priceTarget.parentNode.insertBefore(wrap, priceTarget);
          wrap.appendChild(priceTarget);
          if (discount) wrap.querySelector(':scope > *').appendChild(discount);
        } else if (priceTarget && discount) {
          var existing = priceTarget.parentElement;
          if (!existing.querySelector('.acc-pce__discount')) priceTarget.appendChild(discount);
        }
      }
      if (cardRef) {
        var titleEl = cardRef.querySelector('.product-card__title, .product-card__name, [class*="product-card__title"] a, h3 a, h4 a');
        if (titleEl && !titleEl.querySelector('.acc-pce__title-meta')) {
          var anchorEl = titleEl.tagName === 'A' ? titleEl : titleEl.querySelector('a') || titleEl;
          var fullText = (anchorEl.textContent || '').trim();
          var delim = (CFG.title_delimiter || ' — ');
          var delimTrim = delim.trim();
          var splitMatch = delimTrim ? fullText.split(new RegExp('\\s+' + delimTrim.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&').replace(/[—–-]/g, '[—–-]') + '\\s+')) : [fullText];
          if (splitMatch.length >= 2) {
            var line1 = splitMatch[0].trim();
            var line2 = splitMatch.slice(1).join(delim).trim();
            anchorEl.innerHTML = line1 + '<span class="acc-pce__title-meta">' + line2.replace(/</g,'&lt;') + '</span>';
          }
        }
      }
      var mainImg = cardRef && cardRef.querySelector('img');
      if (mainImg) {
        var originalImgSrc = mainImg.getAttribute('src');
        var originalImgSrcset = mainImg.getAttribute('srcset');
        var isTouchSwatch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
        el.querySelectorAll('[data-color-img]').forEach(function(sw){
          var colorImgUrl = sw.getAttribute('data-color-img');
          if (!colorImgUrl) return;
          if (isTouchSwatch) {
            // MOBILE: tap-to-preview, tap-same-swatch-again-within-3s to navigate
            sw.addEventListener('click', function(e){
              var now = Date.now();
              var last = cardRef.__accLastSwatchTap;
              if (last && last.sw === sw && (now - last.ts) < 3000) {
                // Second tap on same swatch → let the <a> navigate normally
                return;
              }
              // First tap (or tap on a different swatch) → preview only, block navigation
              e.preventDefault();
              e.stopPropagation();
              mainImg.removeAttribute('srcset');
              mainImg.setAttribute('src', colorImgUrl);
              // Clear primed state on other swatches, mark this one primed
              el.querySelectorAll('.acc-pce__swatch--primed').forEach(function(p){ p.classList.remove('acc-pce__swatch--primed'); });
              sw.classList.add('acc-pce__swatch--primed');
              cardRef.__accLastSwatchTap = { sw: sw, ts: now };
            });
          } else {
            // DESKTOP: hover preview, restore on leave
            sw.addEventListener('mouseenter', function(){
              mainImg.removeAttribute('srcset');
              mainImg.setAttribute('src', colorImgUrl);
            });
            sw.addEventListener('mouseleave', function(){
              if (originalImgSrc) mainImg.setAttribute('src', originalImgSrc);
              if (originalImgSrcset) mainImg.setAttribute('srcset', originalImgSrcset);
            });
          }
        });
      }
      el.classList.add('acc-pce--mounted');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountExtras);
  } else {
    mountExtras();
  }
  document.addEventListener('shopify:section:load', mountExtras);
  if (window.MutationObserver) {
    new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { mountExtras(); break; } }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (!CFG.show_hover_cycle) return;
  var HOVER_DELAY = parseInt(CFG.hover_delay_ms, 10) || 700;
  var mediaCache = {};

  function fetchMedia(handle){
    if (!handle) return Promise.resolve([]);
    if (mediaCache[handle]) return mediaCache[handle];
    mediaCache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' }})
      .then(function(r){ return r.json(); })
      .then(function(data){ return (data && data.media || []).map(function(m){ return m.src; }).filter(Boolean); })
      .catch(function(){ return []; });
    return mediaCache[handle];
  }

  function getHandle(card){
    var h = card.getAttribute('handle') || card.dataset.productHandle;
    if (!h) {
      var anchor = card.querySelector('a[href*="/products/"]');
      if (anchor) { var m = anchor.getAttribute('href').match(/\/products\/([^\/?#]+)/); if (m) h = m[1]; }
    }
    return h;
  }

  function bindHover(card){
    if (card.__accHoverBound) return;
    var imgWrap = card.querySelector('.product-card__image, .product-card__media, .product-card__figure, picture');
    if (!imgWrap) { var fi = card.querySelector('img'); if (fi) imgWrap = fi.parentElement; }
    if (!imgWrap) return;
    var img = imgWrap.querySelector('img');
    if (!img) return;
    card.__accHoverBound = true;
    var handle = getHandle(card);
    if (!handle) return;
    var origSrc = img.getAttribute('src'), origSrcset = img.getAttribute('srcset');
    var idx = 0, timer = null, hiddenSiblings = [];

    fetchMedia(handle).then(function(m){
      if (m && m.length >= 2) imgWrap.setAttribute('data-acc-media-count', m.length);
    });

    // Detect touch capability up-front — gate desktop hover-cycle to non-touch only so mobile
    // doesn't auto-cycle when a tap fires the synthetic mouseenter event
    var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    if (!isTouchDevice) {
      // ===== DESKTOP: auto-cycle on hover =====
      imgWrap.addEventListener('mouseenter', function(){
        card.classList.add('acc-pce-cycling');
        hiddenSiblings = [];
        var allImgs = imgWrap.querySelectorAll('img');
        for (var j = 0; j < allImgs.length; j++) {
          if (allImgs[j] !== img) {
            hiddenSiblings.push({ el: allImgs[j], opacity: allImgs[j].style.opacity, visibility: allImgs[j].style.visibility });
            allImgs[j].style.opacity = '0';
            allImgs[j].style.visibility = 'hidden';
          }
        }
        img.style.opacity = '1'; img.style.visibility = 'visible'; img.style.zIndex = '2';
        function startCycle(media){
          if (!media || media.length < 2) return;
          idx = 0;
          img.removeAttribute('srcset');
          img.setAttribute('src', media[0]);
          if (timer) clearInterval(timer);
          timer = setInterval(function(){
            idx = (idx + 1) % media.length;
            img.removeAttribute('srcset');
            img.setAttribute('src', media[idx]);
          }, HOVER_DELAY);
        }
        var cached = mediaCache[handle];
        if (cached && typeof cached.then === 'function') {
          cached.then(function(m){
            if (m && m.length >= 2 && card.classList.contains('acc-pce-cycling')) startCycle(m);
          });
        }
      });

      imgWrap.addEventListener('mouseleave', function(){
        if (timer) clearInterval(timer);
        timer = null; idx = 0;
        card.classList.remove('acc-pce-cycling');
        for (var k = 0; k < hiddenSiblings.length; k++) {
          hiddenSiblings[k].el.style.opacity = hiddenSiblings[k].opacity || '';
          hiddenSiblings[k].el.style.visibility = hiddenSiblings[k].visibility || '';
        }
        hiddenSiblings = [];
        img.style.zIndex = '';
        if (origSrc) img.setAttribute('src', origSrc);
        if (origSrcset) img.setAttribute('srcset', origSrcset);
      });
    }

    // ===== MOBILE: swipe to cycle images + "N/M" counter overlay (manual only, NO auto-cycle) =====
    if (isTouchDevice) {
      var counterEl = null;
      function ensureCounter(total){
        if (counterEl) return counterEl;
        counterEl = document.createElement('span');
        counterEl.className = 'acc-pce-img-counter';
        counterEl.textContent = '1/' + total;
        // Inline styles so we don't require CSS file deploy in lockstep
        counterEl.style.cssText = 'position:absolute;bottom:8px;right:8px;background:rgba(26,26,26,0.75);color:#fff;font-family:inherit;font-size:11px;font-weight:600;padding:2px 7px;border-radius:999px;line-height:1.4;z-index:5;pointer-events:none;letter-spacing:0.02em;';
        // Ensure parent is positioned
        var cs = window.getComputedStyle(imgWrap);
        if (cs.position === 'static') imgWrap.style.position = 'relative';
        imgWrap.appendChild(counterEl);
        return counterEl;
      }
      function updateCounter(current, total){
        var c = ensureCounter(total);
        c.textContent = (current + 1) + '/' + total;
      }

      var touchStartX = 0, touchStartY = 0, touchStartT = 0, swipeIdx = 0, mediaForSwipe = null;
      // Warm the counter as soon as media resolves
      fetchMedia(handle).then(function(m){
        if (m && m.length >= 2) { mediaForSwipe = m; ensureCounter(m.length); updateCounter(0, m.length); }
      });

      imgWrap.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches.length) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartT = Date.now();
      }, { passive: true });

      imgWrap.addEventListener('touchend', function(e){
        if (!e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        var dt = Date.now() - touchStartT;
        // Treat as swipe if horizontal motion > 30px AND mostly horizontal AND under 600ms
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5 && dt < 600) {
          var media = mediaForSwipe || (mediaCache[handle] && mediaCache[handle].then ? null : mediaCache[handle]);
          if (!media || media.length < 2) return; // no images to cycle — let tap pass
          // Prevent the click from firing (which would navigate to product)
          e.preventDefault();
          e.stopPropagation();
          if (dx < 0) { swipeIdx = (swipeIdx + 1) % media.length; }
          else { swipeIdx = (swipeIdx - 1 + media.length) % media.length; }
          img.removeAttribute('srcset');
          img.setAttribute('src', media[swipeIdx]);
          updateCounter(swipeIdx, media.length);
          // Block the impending click event (touchend → click bubble on mobile)
          var blockClick = function(ev){ ev.preventDefault(); ev.stopPropagation(); document.removeEventListener('click', blockClick, true); };
          document.addEventListener('click', blockClick, true);
          setTimeout(function(){ document.removeEventListener('click', blockClick, true); }, 350);
        }
      }, { passive: false });
    }
  }

  function bindAll(){ document.querySelectorAll('product-card:not([data-acc-bound])').forEach(function(c){ c.setAttribute('data-acc-bound', '1'); bindHover(c); }); }
  bindAll();

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(ent){
        if (ent.isIntersecting) {
          var h = getHandle(ent.target);
          if (h) fetchMedia(h);
          io.unobserve(ent.target);
        }
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('product-card').forEach(function(c){ io.observe(c); });
    var mo = new MutationObserver(function(){
      bindAll();
      document.querySelectorAll('product-card:not([data-acc-io-observed])').forEach(function(c){
        c.setAttribute('data-acc-io-observed', '1');
        io.observe(c);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
